"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useErrorEvent = useErrorEvent;
var _subscriptionError = require("@ori-events/subscription-error");
var _react = require("react");
function useErrorEvent() {
  const handleError = (0, _react.useCallback)((...data) => {
    (0, _subscriptionError.dispatch)(...data);
  }, []);
  return {
    handleError
  };
}
